import type { DocMigration } from "../docMigration";

function migrateRailingSetting(setting: any) {
  if (!setting || typeof setting !== "object") {
    return;
  }

  if (setting.baluster?.depth !== undefined) {
    setting.infillDepth = setting.baluster.depth;
    delete setting.baluster.depth;
  }

  if (setting.balusterMaterial !== undefined && setting.infillMaterial === undefined) {
    setting.infillMaterial = setting.balusterMaterial;
    delete setting.balusterMaterial;
  }

  if (setting.balusterSpacing !== undefined) {
    if (!setting.baluster) {
      setting.baluster = {};
    }
    if (setting.baluster.spacing === undefined) {
      setting.baluster.spacing = setting.balusterSpacing;
    }
    delete setting.balusterSpacing;
  }

  if (setting.balusterStartHeight !== undefined) {
    if (!setting.baluster) {
      setting.baluster = {};
    }
    if (setting.baluster.startHeight === undefined) {
      setting.baluster.startHeight = setting.balusterStartHeight;
    }
    delete setting.balusterStartHeight;
  }
}

const migration: DocMigration = {
  id: "20260408_add_solid_infill",
  description:
    "Move balusterSpacing/balusterStartHeight into baluster object, baluster.depth to infillDepth, balusterMaterial to infillMaterial, and removeBalustersBefore/After to removeInfillBefore/After",
  apply(json: any): any {
    const settingsTable = json.settings ?? {};
    for (const settingSet of Object.values(settingsTable)) {
      const setting = settingSet as { type?: string; railingSettingsTable?: Record<string, any> };
      if (setting.type !== "RAILING_CATALOG_SETTINGS") {
        continue;
      }

      const railingSettingsTable = setting.railingSettingsTable ?? {};
      for (const railingSetting of Object.values(railingSettingsTable)) {
        migrateRailingSetting(railingSetting);
      }
    }

    const railings = json.railings ?? {};
    for (const railing of Object.values(railings)) {
      const settingsOverride = (railing as { settingsOverride?: any }).settingsOverride;
      migrateRailingSetting(settingsOverride);
    }

    const railingPosts = json.railingPosts ?? {};
    for (const post of Object.values(railingPosts)) {
      const p = post as any;
      if (p.removeBalustersBefore !== undefined && p.removeInfillBefore === undefined) {
        p.removeInfillBefore = p.removeBalustersBefore;
      }
      delete p.removeBalustersBefore;
      if (p.removeBalustersAfter !== undefined && p.removeInfillAfter === undefined) {
        p.removeInfillAfter = p.removeBalustersAfter;
      }
      delete p.removeBalustersAfter;
    }

    return json;
  },
};

export default migration;
